import React from "react";
import { Modal } from "react-bootstrap";
import { format } from "date-fns";

import { DatePicker } from "../../../Common/Components/DatePicker";
import { ConfirmationModal } from "../../../Common/Components/ConfirmationModal";
import { AddressPicker } from "../../Components/AddressPicker";
import LoginWarning from "../../Components/LoginWarning";

const OrderModals = ({
  cShow,
  setCShow,
  cCart,
  tempServ,
  tempBook,
  count,
  setTempServ,
  setTempBook,
  showPickup,
  sPickup,
  sPSlot,
  pickupRange,
  bookingType,
  HandlePickupChange,
  setShowPickup,
  showDelivery,
  sDelivery,
  sDSlot,
  deliveryRange,
  HandleDeliveryChange,
  setShowDelivery,
  addressModal,
  setAddressModal,
  HandleAddressChange,
  tAddress,
  setTAddress,
  ReplaceAddress,
  loggedIn,
  showWarning,
  setShowWarning,
}) => {
  return (
    <>
      {/* Clear Cart Confirmation */}
      <Modal show={cShow} onHide={() => setCShow(false)} centered>
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="text-primary">Warning...</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className="fw-normal text-center">Are you sure you want to clear your cart?</h5>
        </Modal.Body>
        <Modal.Footer className="border-0 justify-content-between">
          <button className="btn btn-outline-secondary" onClick={() => setCShow(false)}>Cancel</button>
          <button
            className="btn consumer-order-primary fw-semibold"
            onClick={() => {
              setCShow(false);
              cCart();
            }}
          >
            Clear
          </button>
        </Modal.Footer>
      </Modal>

      {/* Warning modal for changing service / booking type */}
      <Modal
        show={tempServ || tempBook}
        onHide={() => {
          setTempServ(null);
          setTempBook(null);
        }}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="text-primary">Warning...</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className="fw-normal text-center">
            You already have {count} item(s) in your cart. If you change{" "}
            {tempBook ? "order type" : "service"} your cart will be cleared.
          </h5>
        </Modal.Body>
        <Modal.Footer className="border-0 justify-content-between">
          <button
            className="btn btn-outline-secondary"
            style={{ width: "49%" }}
            onClick={() => {
              setTempServ(null);
              setTempBook(null);
            }}
          >
            Cancel
          </button>
          <button
            className="btn consumer-order-primary fw-semibold"
            style={{ width: "49%" }}
            onClick={() => {
              cCart(tempBook || tempServ, !Boolean(tempBook));
            }}
          >
            Change {tempBook ? "order type" : "service"}
          </button>
        </Modal.Footer>
      </Modal>

      {/* Pickup date modal */}
      <Modal
        show={showPickup}
        backdrop="static"
        keyboard={false}
        centered
        onHide={() => setShowPickup(false)}
      >
        <Modal.Header closeButton className="py-2">
          <Modal.Title style={{ fontSize: "18px" }}>
            Choose Preferred Date / Time
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showPickup ? (
            <DatePicker
              range={pickupRange}
              selected={sPickup}
              onChange={HandlePickupChange}
              orderType={bookingType}
              timeSlot={sPSlot}
              type={1}
            />
          ) : null}
        </Modal.Body>
      </Modal>

      {/* Delivery date modal */}
      <Modal
        show={showDelivery}
        backdrop="static"
        keyboard={false}
        centered
        onHide={() => setShowDelivery(false)}
      >
        <Modal.Header closeButton className="py-2">
          <Modal.Title style={{ fontSize: "18px" }}>
            Choose Preferred Date / Time
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showDelivery ? (
            <DatePicker
              range={deliveryRange}
              selected={sDelivery}
              onChange={HandleDeliveryChange}
              orderType={bookingType}
              timeSlot={sDSlot}
              pickup={{
                date: sPickup ? format(sPickup, "yyyy-MM-dd") : null,
                slotId: sPSlot?.id,
              }}
              type={2}
            />
          ) : null}
        </Modal.Body>
      </Modal>

      {/* Addresses modal */}
      <AddressPicker
        show={Boolean(addressModal)}
        closeButton={true}
        onHide={() => setAddressModal(null)}
        title={` Select Your ${
          addressModal === "pickup" ? "Pickup " : "Delivery"
        } Address`}
        onSelect={HandleAddressChange}
        showDelete={false}
        showEdit={false}
      />

      {/* Zone change confirmation */}
      <ConfirmationModal
        show={Boolean(tAddress)}
        text="The Address you selected is not in the same zone as you selected in start if you change your zone your cart will be empty. Are your sure you want to change your address?"
        onYes={() => ReplaceAddress(tAddress, true)}
        onNo={() => setTAddress(null)}
      />

      {!loggedIn && showWarning ? (
        <LoginWarning
          onCancel={() => setShowWarning(false)}
          cancelText="Cancel"
        />
      ) : null}
    </>
  );
};

export default OrderModals;
